import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '@/config'
import store from '@/store'
import { canRoute } from '@/roles'
import { isLoggedIn } from '@/plugins/stitch'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [],
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  let title = to.meta.title || store.state.navigation.pageTitle || to.name

  if (title) {
    document.title = `${title} | ${config.title}`
  } else {
    document.title = config.title
  }

  if (to.matched.some(record => record.meta.allowAnonymous || record.name === 'login')) {
    // this route allows no auth or is the /login route
    next()
  } else {
    // By default all pages requires auth
    if (!isLoggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else if (!await canRoute(to)) {
      next('/')
    } else {
      // User logged in
      next()
    }
  }
})

export function hasRoutePermission (to) {
  if (!to) { return true }

  const route = router.resolve(to)
  return canRoute(route ? route.route : null)
}

export default router
